import http from '~/common/http'



//版本列表
function getVersion(params){
    return http.get('/api/common/get-all-versions', {
        params: params
    });
}


export default {
    getVersion,
}


// WEBPACK FOOTER //
// ./src/services/version.js